<template>
  <div>
    <epp-banner :type="3"></epp-banner>
    <div class="menu-main">
      <div class="menu-top" @click="gotoDetail('pipProduct')">
        <div class="left">
          <p class="txt">移液 产品中心</p>
          <p class="col">全线产品，应有尽有</p>
          <p class="line"></p>
        </div>
        <div>
          <img class="pro-img" :src="cdnUrl + 'FjlIKQ8B5LJAG5hxFmO89gb8TirK'" alt="">
        </div>
      </div>
      <div class="menu-bottom">
        <div class="left" @click="gotoDetail('pipetteUse')">
          <p class="f-w-b">移液学院</p>
          <p class="col limit-tip">实用技巧及案例分享 等你探索</p>
          <img :src="cdnUrl + 'Fnnn1rouG71Sq1ETedU7DiJ8a4_s'" alt="">
        </div>
        <div class="right">
          <div class="menu-top-t" @click="gotoDetail('pipSelection')">
            <p class="f-w-b">移液器选型工具</p>
            <p class="col">快速选择移液器及吸头</p>
            <img :src="cdnUrl + 'Ftc2uoKjw82EzlJljyJFobrqQZml'" alt="">
          </div>
          <div class="menu-bot-t" @click="gotoDetail('http://eppendorf.juplus.cn/lifeWithYou/index.html#/afterService_applyRegistration')">
            <div>
              <p class="f-w-b">移液服务申请</p>
              <p class="col">移液器服务登记表</p>
            </div>
            <img :src="cdnUrl + 'FrFnlj_3Nhdn6ewhgLqrlXGIekRB'" alt="">
          </div>
        </div>
      </div>
    </div>
    <footerLine></footerLine>
  </div>
</template>

<script>
import eppBanner from '@/components/eppBanner'
import { centrifugeRecord } from '@/libs/common'
import footerLine from '@/components/footerLine'
import { createdLabel } from '@/api/centrifuge'
export default {
    components:{ eppBanner,footerLine },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            type: '', // 数据记录
        }
    },
    created() {
      let para = {
        type: 35, // 移液器首页记录
        type_id: 0,
        uid: this.$store.state.user.id || 0,
        action: 1
      }
      centrifugeRecord(para) // 人数，次数记录
      this.setLabel()
    },
    methods: {
      setLabel() {
        let para = {
          openid: this.$store.state.user.openid,
          tag_ids: [231,233] // [226,228] --> 测试 [231,233] --> 正式
        }
        createdLabel(para).then(res => {})
      },
        gotoDetail(name) {
            if(!name) {
              this.$toast('敬请期待')
              return
            }
            if(name.indexOf('http') != -1) {
              window.location.href = name
            } else {
              this.$router.push({
                name: name
              })
            }
            
           this.recordHome(name)
        },
        recordHome(name) {
          switch (name){
            case 'pipProduct':
              this.type = 17
              break;
            case 'pipetteUse':
              this.type = 18
              break;
            case 'pipSelection':
              this.type = 19
              break;
            case 'knowUs':
              this.type = 20
              break;
            default: 
              this.type = 17
          }
          let para = {
            type: this.type, // 
            type_id: 0,
            uid: this.$store.state.user.id || 0,
            action: 1
          }
          centrifugeRecord(para) // 人数，次数记录
        }
    }
}
</script>

<style lang="scss" scoped>
.col {
  font-size: 12px;
  color: #9999;
}
.limit-tip {
    width: rem(127);
}
.f-w-b {
  font-size: 16px;
  font-weight: bold;
}
.menu-main {
  .menu-top {
    display: flex;
    justify-content: space-between;
    width: rem(345);
    height: rem(136);
    margin: 0 auto;
    margin-top: rem(15);
    background: linear-gradient(134deg, #F8FFFF 0%, #EDFDFE 100%);
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.07);
    border-radius: 4px;
    border: 1px solid rgba(103,195,216,0.3);
    .pro-img {
      width: rem(130);
      height: rem(130);
    }
    .left {
      position: relative;
      padding-left: rem(20);
    }
    .txt {
      font-size: 20px;
      font-weight: bold;
      margin-top: rem(20);
    }
    .line {
        position: absolute;
        bottom: 10px;
        width: 126px;
        height: 2px;
        background: rgba(108, 197, 219, 0.35);
        border-radius: 4px;
    }
  }
  .menu-bottom {
    display: flex;
    justify-content: center;
    margin-top: rem(15);
    .left {
      position: relative;
      width: rem(165);
      height: rem(215);
      padding: rem(12) 0 0 rem(12);
      margin-right: rem(15);
      background-image: url('https://cdn.juplus.cn/FrgmiwGj_CROckwC1B2rYBRMtRcy');
      background-size: cover;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.07);
      box-sizing: border-box;
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: rem(90);
        height: rem(90);
      }
    }
    .right {
      .menu-top-t {
        position: relative;
        width: rem(165);
        height: rem(140);
        padding: rem(12) 0 0 rem(12);
        background-image: url('https://cdn.juplus.cn/FrzbIJDPrV4HXjDCgjiC4NKzWbP3');
        background-size: cover;
        box-sizing: border-box;
        img {
          position: absolute;
          right: rem(7);
          bottom: rem(5);
          width: rem(60);
          height: rem(60);
        }
      }
      .menu-bot-t {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: rem(165);
        height: rem(60);
        margin-top: rem(15);
        font-size: 12px;
        background-image: url('https://cdn.juplus.cn/Fpi2BKun1HfUsCLbVVo7_N--m3W-');
        background-size: cover;
        img {
          width: rem(38);
          height: rem(38);
        }
      }
    }
  }
}
</style>